module.exports = __webpack_public_path__ + "8b0581c24553d82146f7c5d81a9f84f6.png";